import { Property } from '@/integrations/mysql/types';
import { apiJson, apiJsonArray } from '@/lib/api-client';

class FavoritosService {
  async addToFavoritos(userId: number, propertyId: number): Promise<boolean> {
    try {
      await apiJson(`api/favorites/${userId}/${propertyId}`, {
        method: 'POST',
      });
      return true;
    } catch {
      return false;
    }
  }

  async removeFromFavoritos(userId: number, propertyId: number): Promise<boolean> {
    try {
      const r = await apiJson<{ success: boolean }>(
        `api/favorites/${userId}/${propertyId}`,
        { method: 'DELETE' },
      );
      return r.success;
    } catch {
      return false;
    }
  }

  async isInFavoritos(userId: number, propertyId: number): Promise<boolean> {
    try {
      const r = await apiJson<{ value: boolean }>(
        `api/favorites/has/${userId}/${propertyId}`,
      );
      return r.value;
    } catch {
      return false;
    }
  }

  async getFavoritosProperties(userId: number): Promise<Property[]> {
    try {
      return apiJsonArray<Property>(
        `api/favorites/user/${userId}/properties`,
      );
    } catch {
      return [];
    }
  }

  async getFavoritosCount(userId: number): Promise<number> {
    try {
      const r = await apiJson<{ count: number }>(
        `api/favorites/user/${userId}/count`,
      );
      return r.count;
    } catch {
      return 0;
    }
  }

  async clearFavoritos(userId: number): Promise<boolean> {
    try {
      const r = await apiJson<{ success: boolean }>(
        `api/favorites/user/${userId}/clear`,
        { method: 'DELETE' },
      );
      return r.success;
    } catch {
      return false;
    }
  }
}

export const favoritosService = new FavoritosService();
